import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class DriverVehicleLinkQueryCriteriaClass extends BaseCriteriaModel {

  vehicle_hdr_guid?: Optional<string> = Optional.empty();
  driver_hdr_guid?: Optional<string> = Optional.empty();

}

export class DriverVehicleLinkCriteriaModelQuery {
  query = '';

  constructor(driverVehicleCriteriaModel: DriverVehicleLinkQueryCriteriaClass) {

    if (!driverVehicleCriteriaModel) {
      return;
    }

    this.query += driverVehicleCriteriaModel.vehicle_hdr_guid.filter(x => x !== '').map(x => '&vehicle_hdr_guid=' + x).orElse('');
    this.query += driverVehicleCriteriaModel.driver_hdr_guid.filter(x => x !== '').map(x => '&driver_hdr_guid=' + x).orElse('');

    
    this.query += '&status=' + driverVehicleCriteriaModel.status;
    this.query += '&orderBy=' + driverVehicleCriteriaModel.orderBy;
    this.query += '&order=' + driverVehicleCriteriaModel.order;
    this.query += '&offset=' + driverVehicleCriteriaModel.offset + '&limit=' + driverVehicleCriteriaModel.limit;
  }
}
